import React from "react";
import DashboardIcon from "../../../Asssets/Images/DashboardIcon.svg";
import AttendanceIcon from "../../../Asssets/Images/AttendanceIcon.svg";
import AnnouncementIcon from "../../../Asssets/Images/AnnouncementIcon.svg";
import LeaveManagementIcon from "../../../Asssets/Images/LeaveManagementIcon.svg";
import ProfileIcon from "../../../Asssets/Images/ProfileIcon.svg";
import TicketIcon from "../../../Asssets/Images/TicketsIcon.svg";
import PayrollIcon from "../../../Asssets/Images/payrollIcon.svg";
import PurchaseRequisitionsIcon from "../../../Asssets/Images/PurchaseRequisitions.svg";
import RequestModuleIcon from "../../../Asssets/Images/RequestModule.svg";
import PettyPurchasesIcon from "../../../Asssets/Images/PettyPurchases.svg";
import AssetsIcon from "../../../Asssets/Images/RequestModule.svg";
// Employee Routes
import Dashboard from "../Pages/Dashboard/Dashboard";
import Attendance from "../Pages/Attendance/Attendance";
import Leaves from "../Pages/Leaves/Leaves";
import Announcement from "../Pages/Announcements/Announcement";
import LeaveDetails from "../../HR/Pages/LeaveManagement/LeaveDetails";
import Profile from "../Pages/Profile/Profile";
import Tickets from "../Pages/Tickets/Tickets";
import TicketDetails from "../../HR/Pages/Ticket/TicketDetails";
import Ticket from "../../HR/Pages/Ticket/Ticket";
import Payroll from "../../Employee/Pages/Payroll/Payroll";
import PayrollDetails from "../../HR/Pages/Payroll/payrollDetails";
import Payslip from "../../HR/Pages/Payroll/Payslip/Payslip";
import RequestDetails from "../../HR/Pages/RequestModule/RequestDetails";
import Requests from "../Pages/Requests/Requests";
import PurchaseRequisitions from "../../HR/Pages/PurchaseRequisitions/PurchaseRequisitions";
import PurchaseRequisitionDetails from "../../HR/Pages/PurchaseRequisitions/PurchaseRequisitionDetails";
import PettyPurchases from "../../HR/Pages/PettyPurchases/PettyPurchases";
import PettyPurchaseDetails from "../../HR/Pages/PettyPurchases/PettyPurchaseDetails";
import AssetManagement from "../Pages/Assets/AssetsList";
import AssetDetails from "../Pages/Assets/AssetDetails";
import ProtectedRoute from "../../../Components/ProtectedRoute/ProtectedRoute";

export const getEmployeeRoutes = (user) => {
  const routes = [
    {
      path: "/employee/dashboard",
      component: <Dashboard />,
    },
    {
      path: "/employee/profile",
      component: <Profile />,
    },
    {
      path: "/employee/attendance",
      component: <Attendance />,
    },
    {
      path: "/employee/leaves",
      component: <Leaves />,
    },
    {
      path: "/employee/leaves/:id",
      component: <LeaveDetails />,
    },
    {
      path: "/employee/announcement",
      component: <Announcement />,
    },
    {
      path: "/employee/requests",
      component: <Requests user="employee" />,
    },
    {
      path: "/employee/request/:id",
      component: <RequestDetails />,
    },
    {
      path: "/employee/payroll",
      component: <Payroll />,
    },
    {
      path: "/employee/payroll/:id",
      component: <PayrollDetails />,
    },
    {
      path: "/employee/payroll/payslip/:id",
      component: <Payslip />,
    },
    // Purchase Requisitions - Only visible to Accounts and Admin departments
    {
      path: "/employee/purchase-requisitions",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "63d8c6158c662fd4d455ce85",
          ]}
          allowedRoles={["employee", "HR", "admin"]}
        >
          <PurchaseRequisitions />
        </ProtectedRoute>
      ),
    },
    {
      path: "/employee/purchase-requisition/:id",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "63d8c6158c662fd4d455ce85",
          ]}
          allowedRoles={["employee", "HR", "admin"]}
        >
          <PurchaseRequisitionDetails />
        </ProtectedRoute>
      ),
    },
    {
      path: "/employee/petty-purchases",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "63d8c6158c662fd4d455ce85",
            "6698ff124aa01ad1714d88b3",
          ]}
          allowedRoles={["employee", "HR", "admin"]}
        >
          <PettyPurchases />
        </ProtectedRoute>
      ),
    },
    {
      path: "/employee/purchase-requisition/:id",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "63d8c6158c662fd4d455ce85",
            "6698ff124aa01ad1714d88b3",
          ]}
          allowedRoles={["employee", "HR", "admin"]}
        >
          <PettyPurchaseDetails />
        </ProtectedRoute>
      ),
    },
    {
      path: "/employee/assets",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "6698ff124aa01ad1714d88b3",
          ]}
          allowedRoles={["employee", "admin"]}
        >
          <AssetManagement />
        </ProtectedRoute>
      ),
    },
    {
      path: "/employee/assets/:id",
      component: (
        <ProtectedRoute
          allowedDepartments={[
            "68875ce1f9c0eda4dcce9c74",
            "6392e6b4758449db0ae81600",
            "6698ff124aa01ad1714d88b3",
          ]}
          allowedRoles={["employee", "admin"]}
        >
          <AssetDetails />
        </ProtectedRoute>
      ),
    },
  ];

  // Conditionally add the Tickets route for only the allowed user
  if (user?.employee?._id === "6887259cf9c0eda4dccaa1d2") {
    routes.push(
      {
        path: "/employee/tickets",
        component: <Ticket />,
      },
      {
        path: "/employee/ticket-details/:id",
        component: <TicketDetails />,
      }
    );
  } else {
    routes.push(
      {
        path: "/employee/tickets",
        component: <Tickets />,
      },
      {
        path: "/employee/tickets/:id",
        component: <TicketDetails />,
      }
    );
  }

  return routes;
};

export const employeeSideBarItems = [
  {
    path: "/employee/dashboard",
    icon: <DashboardIcon />,
    title: "Dashboard",
    isSubNav: false,
  },
  {
    path: "/employee/profile",
    icon: <ProfileIcon />,
    title: "Profile",
    isSubNav: false,
  },

  {
    path: "/employee/attendance",
    icon: <AttendanceIcon />,
    title: "Attendance",
    isSubNav: false,
  },
  {
    path: "/employee/requests",
    icon: <RequestModuleIcon />,
    title: "Request Module",
    isSubNav: false,
  },
  // Purchase Requisitions & Petty Purchase - Only visible to Accounts and Admin departments
  {
    path: "/employee/purchase-requisitions",
    icon: <PurchaseRequisitionsIcon />,
    title: "Purchase Requisitions",
    isSubNav: false,
    restricted: true,
    allowedDepartments: [
      "68875ce1f9c0eda4dcce9c74",
      "6392e6b4758449db0ae81600",
      "63d8c6158c662fd4d455ce85",
    ],
  },
  {
    path: "/employee/petty-purchases",
    icon: <PettyPurchasesIcon />,
    title: "Petty Purchases",
    isSubNav: false,
    restricted: true,
    allowedDepartments: [
      "68875ce1f9c0eda4dcce9c74",
      "6392e6b4758449db0ae81600",
      "63d8c6158c662fd4d455ce85",
    ],
  },
  {
    path: "/employee/announcement",
    icon: <AnnouncementIcon />,
    title: "Announcement",
    isSubNav: false,
  },

  {
    path: "/employee/leaves",
    icon: <LeaveManagementIcon />,
    title: "Leave Applications",
    isSubNav: false,
  },
  {
    path: "/employee/tickets",
    icon: <TicketIcon />,
    title: "Tickets",
    isSubNav: false,
  },
  {
    path: "/employee/payroll",
    icon: <PayrollIcon />,
    title: "Payroll",
    isSubNav: false,
  },
  {
    path: "/employee/assets",
    icon: <AssetsIcon />,
    title: "Assets",
    isSubNav: false,
    restricted: true,
    allowedDepartments: [
      "6392e6b4758449db0ae81600",
      "68875ce1f9c0eda4dcce9c74",
      "6698ff124aa01ad1714d88b3",
    ],
  },
];
